import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { BaseComponent } from "primeng/basecomponent";
import { SidenavHeaderStyle } from "./sidenav-header.style";

@Component({
  selector: "ui-sidenav-header",
  templateUrl: "./sidenav-header.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "[class]": "cx('root')" },
})
export class SidenavHeaderComponent extends BaseComponent {
  protected readonly _componentStyle = inject(SidenavHeaderStyle);
}
